import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { startLoadingActionsByProject } from '../../actions/action';
import buildMiddleware from './template';
const withActionsFetch = SubComponent => {
  const WithActionsFetchWrapper = buildMiddleware(SubComponent, 'WithActions');
  const WithActionsFetch = class extends Component {
    componentDidMount() {
      this.props.startLoadingActionsByProject();
    }
    render() {
      const {
        startLoadingActionsByProject,
        ...passThroughProps
      } = this.props;
      return /*#__PURE__*/React.createElement(WithActionsFetchWrapper, passThroughProps);
    }
  };
  const mapStateToProps = _ref => {
    let {
      action
    } = _ref;
    return {
      loading: action.actionsLoading || !action.actions && !action.actionsError,
      error: action.actionsError
    };
  };
  const mapDispatchToProps = dispatch => ({
    startLoadingActionsByProject: () => dispatch(startLoadingActionsByProject())
  });
  WithActionsFetch.propTypes = {
    startLoadingActionsByProject: PropTypes.func.isRequired
  };
  return connect(mapStateToProps, mapDispatchToProps)(WithActionsFetch);
};
export default withActionsFetch;